import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_LIEFERANTENSTAMM_WWS } from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierWws } from '../types/supplier-wws';

@Injectable()
export class LieferantenWwsRepository extends ReadonlyHttpApiRepository<
  Result<SupplierWws>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_WWS);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
